import {
  CompassionSundayBaseFormData,
  CompassionSundayRegistrationFormData,
  LeadChurchRequest,
  SubscriptionRequest,
} from '@sola/schema/lib/skippy.js';
import { httpPostWithStatus } from '@sola/shared-utils/httpClient.js';

const apiRouteBase = '/api';
const compassionSundayRouteBase = `${apiRouteBase}/compassion-sunday`;

/**
 * Send an email subscription request to the Skippy API
 */
export const submitSubscription = async (req: SubscriptionRequest) => {
  // TODO: do we need any CSRF protection here? How do we accomplish that with Next.js?
  const { statusCode } = await httpPostWithStatus(
    `${apiRouteBase}/subscriptions/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};

/**
 * * Send a Compassion Sunday Plannding Guide request to the Skippy API
 */
export const submitLeadChurchForm =
  (leadType: string, subscriptionCode: string) =>
  async (req: LeadChurchRequest) => {
    const { statusCode } = await httpPostWithStatus(
      `${apiRouteBase}/leads/`,
      {
        ...req,
        leadType,
        subscriptionCode,
      },
      { signRequest: true },
    );
    return statusCode >= 200 && statusCode < 300;
  };

/**
 * Send a Compassion Sunday registration request to the Skippy API
 */
export const submitCompassionSundayRegistration = async (
  req: CompassionSundayRegistrationFormData,
) => {
  const { statusCode } = await httpPostWithStatus(
    `${compassionSundayRouteBase}/registration/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};

/**
 * Send a Compassion Sunday Plannding Guide request to the Skippy API
 */
export const submitCompassionSundayPlanningGuide = async (
  req: CompassionSundayBaseFormData,
) => {
  const { statusCode } = await httpPostWithStatus(
    `${compassionSundayRouteBase}/planning-guide/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};
